import brandEdit, { BrandEditState } from './BrandEdit/brand-edit-reducer';
import storyPublish, {
  StoryPublishState,
} from './StoryPublish/story-publish.reducer';
import brandList, { BrandListState } from './BrandList/brandlist.reducer';
import snackbar, { SnackbarState } from './Snackbar/snackbar.reducer';
import streamCategoryConfig, {
  StreamCategoryConfigState,
} from './StreamCategoryConfig/stream-category-config.reducer';
import { combineReducers } from 'redux';
import auth, { User } from './Auth/auth.reducer';
import storyList, { StoryListState } from './StoryList/storylist.reducer';
import { routerReducer } from 'react-router-redux';
import entities, { Entities } from './Entities/entities.reducer';
import clusterList, {
  ClusterListState,
} from './ClusterList/clusterlist.reducer';
import storyEdit, { StoryEditState } from './StoryEdit/story-edit.reducer';
import navigation, { Navigation } from './Navigation/navigation.reducer';
import clusterEdit, {
  ClusterEditState,
} from './ClusterEdit/cluster-edit.reducer';
import featuredClusterEdit, {
  FeaturedClusterEditState,
} from './FeaturedClusterEdit/featured-cluster-edit.reducer';
import copyStreamCategories, {
  CopyStreamCategoriesState,
} from './CopyStreamCategories/copy-stream-categories.reducer';

export interface AppState {
  routerReducer: any;
  auth: User;
  entities: Entities;
  storyList: StoryListState;
  clusterList: ClusterListState;
  brandList: BrandListState;
  navigation: Navigation;
  streamCategoryConfig: StreamCategoryConfigState;
  storyEdit: StoryEditState;
  brandEdit: BrandEditState;
  snackbar: SnackbarState;
  clusterEdit: ClusterEditState;
  storyPublish: StoryPublishState;
  featuredClusterEdit: FeaturedClusterEditState;
  copyStreamCategories: CopyStreamCategoriesState;
}

export interface KeyMap<T> {
  [key: string]: T;
}

export interface EntityStore<T> {
  byId: KeyMap<T>;
}

export default combineReducers<AppState>({
  routerReducer: routerReducer as any,
  auth,
  storyList,
  entities,
  clusterList,
  navigation,
  streamCategoryConfig,
  storyEdit,
  snackbar,
  clusterEdit,
  brandList,
  storyPublish,
  brandEdit,
  featuredClusterEdit,
  copyStreamCategories,
});



// WEBPACK FOOTER //
// ./src/store/reducers.ts